import { parse } from "query-string";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import { _Set_Cart } from "../../../store/actions/cart_actions";
import { useLangNavigate } from "../../../hooks/useLangNavigate";

const PaymentResult = (props) => {
  const { clearCarts } = props;

  const location = useLocation();
  const navigate = useLangNavigate();

  if (parse(location.search).redirect_status === "succeeded") {
    clearCarts();
    navigate(`/payment/done/123${location.search}`);
  } else {
    navigate(`/payment/error/123${location.search}`);
  }

  return null;
};

const mapDispatchToProps = (dispatch) => {
  return {
    clearCarts: () => dispatch(_Set_Cart([])),
  };
};

export default connect(null, mapDispatchToProps)(PaymentResult);
